import React, { useState } from "react";
import "./MVP.css";

export default function MVP() {
  const [form, setForm] = useState({
    reactants: "",
    catalyst: "",
    surfactants: "",
    operating_temp: "",
    operating_pressure: "",
    desired_output: "",
    target_yield: "",
    constraints: "",
  });

  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResult("");

    try {
      const response = await fetch("http://localhost:8000/optimize", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (!response.ok) throw new Error("Backend request failed");

      const data = await response.json();
      setResult(data.result);
    } catch (error) {
      setResult("Error: Could not optimize process. Please check that the backend server is running.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mvp-form">
      {/* Synthera Logo Banner */}
      <div className="logo-banner">
        <a href="/">
          <img src={`${process.env.PUBLIC_URL}/assets/logo.png`} alt="Synthera Logo" className="logo-large" />
        </a>
      </div>

      <h1>Test the Synthera AI Optimiser</h1>
      <p>Enter your reaction details below. If unsure, try the example values.</p>

      <form onSubmit={handleSubmit}>
        <label>
          Reactants
          <input
            type="text"
            name="reactants"
            placeholder="Ethanol, Acetic Acid"
            value={form.reactants}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Catalyst
          <input
            type="text"
            name="catalyst"
            placeholder="e.g. Sulfuric Acid"
            value={form.catalyst}
            onChange={handleChange}
          />
        </label>

        <label>
          Surfactants
          <input
            type="text"
            name="surfactants"
            placeholder="e.g. Sodium Dodecyl Sulfate"
            value={form.surfactants}
            onChange={handleChange}
          />
        </label>

        <label>
          Operating Temperature (°C)
          <input
            type="number"
            name="operating_temp"
            placeholder="e.g. 25"
            value={form.operating_temp}
            onChange={handleChange}
          />
        </label>

        <label>
          Operating Pressure (atm)
          <input
            type="number"
            name="operating_pressure"
            placeholder="e.g. 1"
            value={form.operating_pressure}
            onChange={handleChange}
          />
        </label>

        <label>
          Desired Output
          <input
            type="text"
            name="desired_output"
            placeholder="e.g. Ethyl Acetate"
            value={form.desired_output}
            onChange={handleChange}
          />
        </label>

        <label>
          Target Yield (%)
          <input
            type="number"
            name="target_yield"
            placeholder="e.g. 85"
            value={form.target_yield}
            onChange={handleChange}
          />
        </label>

        <label>
          Constraints
          <textarea
            name="constraints"
            placeholder="e.g. Minimize energy usage, avoid toxic solvents"
            value={form.constraints}
            onChange={handleChange}
          />
        </label>

        <button type="submit" className="cta-btn" disabled={loading}>
          {loading ? "Optimizing..." : "Run Optimisation"}
        </button>
      </form>

      {result && (
        <div className="result">
          <h2>AI Suggestions</h2>
          <pre>{result}</pre>
        </div>
      )}
    </div>
  );
}



